import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.assign("/dashboard");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#C46B4E]/10 flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-[#C46B4E]" />
            </div>
            <h2 className="font-heading text-3xl text-[#2A2621] mt-5">A quiet moment, please</h2>
            <p className="text-[#615A50] mt-2 leading-relaxed">
              Something on this page didn't load the way it should. Nothing is lost — let's take you back to the Sanctuary.
            </p>
            <button onClick={this.handleReset} data-testid="error-boundary-reset"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[#3D5844] text-white px-6 py-3 font-medium hover:bg-[#2F4535] transition-colors">
              <RotateCcw className="w-4 h-4" /> Return to Sanctuary
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
